'use strict';
require('../../modules/esnext.object.iterate-entries');
var path = require('../../internals/path');

module.exports = path.Object.iterateEntries;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/full/object/iterate-entries.js
// module id = 363
// module chunks = 0